// extracted by mini-css-extract-plugin
export var alignDiscLeft = "t_sc d_fp d_bG d_dv";
export var alignLeft = "t_rd d_fp d_bG d_dv";
export var alignDiscCenter = "t_sd d_fq d_bD d_dw";
export var alignCenter = "t_bP d_fq d_bD d_dw";
export var alignDiscRight = "t_sf d_fr d_bH d_dx";
export var alignRight = "t_rf d_fr d_bH d_dx";
export var footerContainer = "t_sg d_dW d_bW";
export var footerContainerFull = "t_sh d_dT d_bW";
export var footerHeader = "t_kf d_kf";
export var footerTextWrapper = "t_sj d_w";
export var footerDisclaimerWrapper = "t_km d_km d_ck";
export var badgeWrapper = "t_sk d_w d_bz d_bP d_bF d_bJ";
export var verticalTop = "t_sl d_bz d_bJ d_bN d_bL";
export var wide = "t_sm d_cy";
export var right = "t_sn d_bK";
export var line = "t_fk d_fl d_cv";
export var badgeDisclaimer = "t_sp d_bC d_bP d_bJ";
export var badgeContainer = "t_sq d_bz d_bH d_bP";
export var badge = "t_sr";
export var padding = "t_ss d_c7";
export var end = "t_st d_bH";
export var linkWrapper = "t_sv d_dB";
export var link = "t_mC d_dB";
export var colWrapper = "t_sw d_cx";
export var consent = "t_f d_f d_bC d_bP";
export var disclaimer = "t_sx d_bz d_bJ";
export var media = "t_sy d_bx d_dy";
export var itemRight = "t_sz";
export var itemLeft = "t_sB";
export var itemCenter = "t_sC";
export var exceptionWeight = "t_sD y_tb";